import React, { useState } from 'react';
import '../Explore.css';

const albums = [
  { title: 'Future Nostalgia', artist: 'Dua Lipa', cover: 'https://images.unsplash.com/photo-1511671782779-c97d3d27a1d4?auto=format&fit=crop&w=400&q=80' },
  { title: 'After Hours', artist: 'The Weeknd', cover: 'https://images.unsplash.com/photo-1506744038136-46273834b3fb?auto=format&fit=crop&w=400&q=80' },
  { title: 'Divide', artist: 'Ed Sheeran', cover: 'https://upload.wikimedia.org/wikipedia/en/4/45/Divide_cover.png' },
  { title: 'When We All Fall Asleep', artist: 'Billie Eilish', cover: 'https://images.unsplash.com/photo-1519125323398-675f0ddb6308?auto=format&fit=crop&w=400&q=80' },
  { title: 'Random Access Memories', artist: 'Daft Punk', cover: 'https://images.unsplash.com/photo-1515378791036-0648a3ef77b2?auto=format&fit=crop&w=400&q=80' },
  { title: 'AM', artist: 'Arctic Monkeys', cover: 'https://images.unsplash.com/photo-1465101046530-73398c7f28ca?auto=format&fit=crop&w=400&q=80' },
  { title: 'Fine Line', artist: 'Harry Styles', cover: 'https://images.unsplash.com/photo-1511671782779-c97d3d27a1d4?auto=format&fit=crop&w=400&q=80' },
  { title: 'Lover', artist: 'Taylor Swift', cover: 'https://images.unsplash.com/photo-1506744038136-46273834b3fb?auto=format&fit=crop&w=400&q=80' },
  { title: 'Justice', artist: 'Justin Bieber', cover: 'https://images.unsplash.com/photo-1519125323398-675f0ddb6308?auto=format&fit=crop&w=400&q=80' },
  { title: "Hollywood's Bleeding", artist: 'Post Malone', cover: 'https://images.unsplash.com/photo-1515378791036-0648a3ef77b2?auto=format&fit=crop&w=400&q=80' },
  { title: 'SOUR', artist: 'Olivia Rodrigo', cover: 'https://images.unsplash.com/photo-1465101046530-73398c7f28ca?auto=format&fit=crop&w=400&q=80' },
  { title: 'Scorpion', artist: 'Drake', cover: 'https://images.unsplash.com/photo-1511671782779-c97d3d27a1d4?auto=format&fit=crop&w=400&q=80' },
];

export default function Explore() {
  const [search, setSearch] = useState('');
  const filtered = albums.filter(a =>
    a.title.toLowerCase().includes(search.toLowerCase()) ||
    a.artist.toLowerCase().includes(search.toLowerCase())
  );
  return (
    <div className="explore-root">
      <h1>Explorer la musique</h1>
      <div className="explore-search">
        <input
          type="text"
          placeholder="Rechercher un album ou un artiste..."
          value={search}
          onChange={e => setSearch(e.target.value)}
        />
      </div>
      <div className="explore-grid">
        {filtered.map((a, i) => (
          <div className="explore-card" key={i}>
            <img src={a.cover} alt={a.title} />
            <div className="explore-info">
              <strong>{a.title}</strong>
              <span>{a.artist}</span>
            </div>
          </div>
        ))}
        {filtered.length === 0 && <div className="explore-empty">Aucun résultat</div>}
      </div>
    </div>
  );
} 